/**
 * Popup.js
 * 
 * create file	2015-01-15
 * last update	2015-07-24
 * 
 * comment
 * 팝업
 */
var Popup = (function($){
	function Popup(option){
		if(!option) return;
		
		this._option = option;
		this._initChk = false;
		this._$win = $(window);
		this._$wrap = $('body');

		this._btnSelector = option.btnSelector;
		this._popupSelector = option.popupSelector;
		if(typeof this._popupSelector == 'object') this._popupSelector = this._popupSelector.selector;
		this._clone = option.clone == undefined ? false : option.clone;
		this._panelClass = option.panelClass == undefined ? null : option.panelClass;
		
		this._drag = option.drag == undefined ? false : option.drag; 
		this._dimmed = option.dimmed == undefined ? true : option.dimmed;
		this._dimmedColor = option.dimmedColor == undefined ? 'rgba(255,255,255,.0)' : option.dimmedColor; // 'rgba(255,255,255,.0)'
		this._$dimmed = $('<div>' , {'class' : 'dimmed-layer'});
		
		this._closeSelector = option.closeSelector == undefined ? '.pop-header button' : option.closeSelector;
		this._okSelector = option.okSelector == undefined ? '.js-ok' : option.okSelector;
		this._cancelSelector = option.cancelSelector == undefined ? '.js-cancel' : option.cancelSelector;
		this._yesSelector = option.yesSelector == undefined ? '.js-yes' : option.yesSelector;
		this._noSelector = option.noSelector == undefined ? '.js-no' : option.noSelector;
		
		this._$btn = $(this._btnSelector).addClass('js-popup-btn');
		if(this._clone){
			$(this._popupSelector).hide();
			this._$popup = $(this._popupSelector+':not(.js-popup)').eq(0).clone().addClass('js-popup').css('z-index' , '2000').hide();
			this._$popup .find('.js-sub-select').removeClass('js-sub-select');
			this._$popup .find('.js-sub-tree').removeClass('js-sub-tree');
			$(this._popupSelector+':not(.js-popup)').eq(0).after(this._$popup);
		} else {
			this._$popup = $(this._popupSelector).addClass('js-popup').css('z-index' , '2000').hide();
			this._$popupBackup = this._$popup.clone();
		}

		this._keyEvt = function(){
			var _this = this;
			
			// esc 키 닫기 20180726
			this._$popup.bind('keydown.popup', function(e){
				if(e.keyCode == 27){
					_this.hide();
				}
			});


			// 레이어박스에 a, button, input 에 data값 설정 (포커스 제어 위해서)
			this._$popup.find('a, button, input').each(function(i){
				$(this).data('popup-focus-idx' , i);
			});

			// 탭 , 위, 아래
			this._$popup.bind('keydown.popup', function(e){
				// 탭키 포커스 제어

   			if($(e.target).filter(':input').size() > 0) return;
				

				
				if( e.keyCode == 9 && e.shiftKey){
					if($(this).is(':focus')){
						$(this).find('a:visible, button:visible, input:visible').eq(-1).focus();
						return false;
					}
				}

				// up , left
				if(e.keyCode == 38 || e.keyCode == 37){
					if($(this).is(':focus')){
						$(this).find('a:visible, button:visible, input:visible').eq(-1).focus();
					} else {
						var getFocusIdx = $(this).find(':focus').data('popup-focus-idx');
						for(var i=getFocusIdx; i>=0; i--){
							getFocusIdx--;
							
							// getFocusIdx의 포커스 이동할 영역이 보이거나 인풋태그면서 보이거나
							if($(this).find('a, button, input').eq(getFocusIdx).is(':visible') || 
								($(this).find('a, button, input').eq(getFocusIdx).parent().hasClass('check') && $(this).find('a, button, input').eq(getFocusIdx).parent().is(':visible')) ||
								($(this).find('a, button, input').eq(getFocusIdx).parent().hasClass('radio-des') && $(this).find('a, button, input').eq(getFocusIdx).parent().is(':visible')) ){
								break;
							}
						}
						
						$(this).find('a, button, input').eq(getFocusIdx).focus();
						if(getFocusIdx < 0){
							$(this).find('a:visible, button:visible, input:visible').eq(-1).focus();
						}
					}
					return false;
				}

				// down , right
				if(e.keyCode == 40 || e.keyCode == 39){
					if($(this).is(':focus')){
						$(this).find('a:visible, button:visible, input:visible').eq(0).focus();
					} else {
						var getFocusIdx = $(this).find(':focus').data('popup-focus-idx');
						for(var i=getFocusIdx; i<$(this).find('a, button, input').length; i++){
							getFocusIdx++;
							if(getFocusIdx >= $(this).find('a, button, input').length){
								getFocusIdx = 0;
							}
							
							// getFocusIdx의 포커스 이동할 영역이 보이거나 인풋태그면서 보이거나
							if($(this).find('a, button, input').eq(getFocusIdx).is(':visible') || 
								($(this).find('a, button, input').eq(getFocusIdx).parent().hasClass('check') && $(this).find('a, button, input').eq(getFocusIdx).parent().is(':visible')) ||
								($(this).find('a, button, input').eq(getFocusIdx).parent().hasClass('radio-des') && $(this).find('a, button, input').eq(getFocusIdx).parent().is(':visible')) ){
								break;
							}
						}
						$(this).find('a, button, input').eq(getFocusIdx).focus();
					}
					return false;
				}
			});

			// 탭키 포커스 제어
			this._$popup.find('a, button, input').eq(-1).bind('keydown.popup', function(e){
				if(e.keyCode == 9 && !e.shiftKey){
					if($(this).is(':focus')){
						_this._$popup.focus();
						return false;
					}
				}
			});
		}
		
		// 버튼 종류 추후에 이벤트 추가
		// 확인(ok), 취소(cancel), 예(yes), 아니오(no), 저장(save), 검색(search), 이동(move), 계속 이동, 상신취소, 불러오기
		this._btnEvt = function(){
			var _this = this;

			// ok
			if(typeof (this._option.ok) === 'function'){
				this._$popup.find(this._okSelector).bind('click.popup', function(){
					_this._option.ok();
					//_this.hide();
				});
			}
			
			// cancel
			if(typeof (this._option.cancel) === 'function'){
				this._$popup.find(this._cancelSelector).bind('click.popup', function(){
					_this._option.cancel();
					//_this.hide();
				});
			}

			// yes
			if(typeof (this._option.yes) === 'function'){
				this._$popup.find(this._yesSelector).bind('click.popup', function(){
					_this._option.yes();
					//_this.hide();
				});
			}

			// no
			if(typeof (this._option.no) === 'function'){
				this._$popup.find(this._noSelector).bind('click.popup', function(){
					_this._option.no();
					//_this.hide();
				});
			}
			
			// close
			this._$popup.find(this._closeSelector).bind('click.popup', function(){
				_this.hide();
			});
		}
		
		this._rgbToHex = function(rgb){
			rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
			return (rgb && rgb.length === 4) ? "#" +
			("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
			("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
			("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
		}
		
		$.fn.isScrollable = function(){
			var elem = $(this);
			return (
			elem.css('overflow') == 'scroll'
				|| elem.css('overflow') == 'auto'
				|| elem.css('overflow-x') == 'scroll'
				|| elem.css('overflow-x') == 'auto'
				|| elem.css('overflow-y') == 'scroll'
				|| elem.css('overflow-y') == 'auto'
			);
		};

		$.fn.hasScrollBar = function (){
			return this.get(0).scrollHeight > this.get(0).clientHeight;
		}
		
		this.init();

		// 이벤트 추가
		if(typeof (this._option.addEvt) === 'function'){
			this.addEvt();
		}
	}
	
	Popup.prototype.init = function(){
		if(this._initChk) return;

		var _this = this;
		
		this._globalLayerDeleteHandler = function(e , classValue){
			if(_this._panelClass == classValue){
				_this.destroy();
			}
		}

		// 인스턴스 생성될때 같은 이름의 경우 자체 디스토리 시키기
		if(this._panelClass != null){
			$(window).unbind('customEvent.globalLayerDelete' , this._globalLayerDeleteHandler);
			$(window).bind('customEvent.globalLayerDelete' , this._globalLayerDeleteHandler);
		}

		// 클론 시 레이어안 인풋요소 아이디, 네임값, 레이블 for 속성값 변경필요
		if(this._clone){
			if(this._$popup.find('input').length > 0){
				var idNum = 0;
				this._$popup.find('input').each(function(){
					idNum++;
					var count = '_popup'+ $('.js-popup').length + '_' +idNum;
					$(this).attr('id' , $(this).attr('id') + count);
					$(this).attr('name' , $(this).attr('name') + $('.js-popup').length);
					$(this).next('label').attr('for' , $(this).next('label').attr('for') + count);
				});
			}
		}

		// 버튼에 인덱스값 부여 ( 활성화된 버튼 알기 위해 )
		this._$btn.each(function(i){
			$(this).data('popup-btn-idx' , i);
		});
		
		if(this._drag){
			// 스크롤영역 체크
			this._$popup.find('*').each(function(){
				if($(this).isScrollable() || $(this).hasScrollBar() ){
					$(this).addClass('js-has-scroll');
				}
			});
			
			this._$popup.draggable({
				scroll: false,
				containment: this._$wrap,
				handle: '.pop-header',
				start: function(e) {
					if($(this).data('scrolled')){
						$(this).data('scrolled', false).trigger('mouseup');
						return false;
					}
				},
				drag : function(e, ui){
					var obj = ui.helper;
					// 팝업에서 드래그시 열린 셀렉트 메뉴 닫기
					if(obj.find('.js-layer-btn.js-active-select').length > 0){
						obj.find('.js-layer-btn.js-active-select').trigger('layerHide');
					}
				}
			}).find('*').andSelf().bind('scroll.popup' , function(){
				$(this).parents('.ui-draggable').data('scrolled', true);
			});
		}

		if(this._dimmed){
			this._$dimmed.css({
				'position' : 'absolute',
				'z-index' : '2000',
				'left' : 0,
				'top' : 0,
				'width' : '100%',
				'height' : '100%',
				'display' : 'none',
				'cursor' : 'default',
				'background' : this._dimmedColor
			});
			
			// ie 7,8 체크 ( background 에 rgba값이 적용되지 않기 때문에 )
			if(navigator.appVersion.indexOf("MSIE 8.")!=-1 || navigator.appVersion.indexOf("MSIE 7.")!=-1){
				this._$dimmed.css({
					'background' : this._rgbToHex(this._dimmedColor),
					'opacity' : this._dimmedColor.replace(/^.*,(.+)\)/,'$1')
				});
			}

			this._$popup.before(this._$dimmed);
			this._$dimmed.bind('click.popup' , function(e){
				e.preventDefault();
				e.stopPropagation();
				
				// 팝업위에 셀렉트 메뉴 있을시에 딤드 클릭시 셀렉트 닫기
				if(_this._$dimmed.next('.js-popup').find('.js-layer-btn').length > 0){
					_this._$dimmed.next('.js-popup').find('.js-layer-btn').trigger('layerHide');
				}
			});
		}

		this._keyEvt(); // 키 이벤트 ( 포커스 제어 하기 위해 )
		this._btnEvt(); // 버튼 이벤트
		
		// 레이어 보기 이벤트
		this._$btn.bind('click.popup', function(e){
			//e.stopPropagation();
			_this._$popup.data('popup-btn-idx' , $(this).data('popup-btn-idx'));
			_this.show($(this));
		});

		// Popup 인스턴스 위에 SelectMenu가 떠야 할 경우 ( 팝업 클릭시 셀렉트메뉴 숨기기 위해)
		this._$popup.bind('click.popup' , function(e){
			e.stopPropagation();

			// SelectMenu
			if(!_this._$popup.find('.js-layer-btn.js-active-select').is(e.target) && _this._$popup.find('.js-layer-btn.js-active-select').has(e.target).length === 0 ){
				_this._$popup.find('.js-layer-btn.js-active-select').trigger('layerHide');
			}
			// subSelect
			if(!_this._$popup.find('.select02.js-sub-select').is(e.target) && _this._$popup.find('.select02.js-sub-select').has(e.target).length === 0 ){
				_this._$popup.find('.select02.js-sub-select').trigger('layerHide');
			}
		});
		
		// 서브플러그인 있을경우
		if(this._$popup.find('.select02:not(.js-sub-select)').length > 0){
			this._$popup.find('.select02:not(.js-sub-select)').subSelect();
		}
		if(this._$popup.find('.tree-st01:not(.js-sub-tree)').length > 0){
			this._$popup.find('.tree-st01:not(.js-sub-tree)').treeSet();
		}
		
		this._initChk = true;
	}
	
	Popup.prototype.show = function(target){
		var _this = this;
		var $target = target;
		
		if(!this._dimmed){
			setTimeout(function(){
				// 딤드가 false 일때 바닥 클릭시
				
				$(document).bind('click.popup_' + this._popupSelector, function(e){
					// 2015-07-24 일정 상세검색 datepicker 이전월 다음월 변경시 레이어 닫히지 않도록 예외처리
					if($(e.target).hasClass('ui-icon-circle-triangle-w') || $(e.target).hasClass('ui-icon-circle-triangle-e')) return;
					
					if(!$(_this._popupSelector).is(e.target) && $(_this._popupSelector).has(e.target).length === 0 
						&& _this._$popup.is(':visible')
						&& !$('.js-layer-box').is(e.target) && $('.js-layer-box').has(e.target).length === 0 
						&& !$(_this._btnSelector).is(e.target) && $(_this._btnSelector).has(e.target).length === 0){
						// _this._$popup 다음 노드중에 $('.dimmed-layer:visible').length <= 0 일때 하이드
						if(_this._$popup.nextAll('.dimmed-layer:visible').length <= 0){
							_this.hide();
						}
					}
				});
			}, 0);
		}
		
		// TODO 2015-03-06
		/*
		// 보여지는 팝업이 있을경우 숨김
		if($('.js-popup').is(':visible')){
			//$('.js-popup').removeAttr('tabindex').hide();

			// dimmed 있을경우 숨김
			if($('.dimmed-layer').is(':visible')){
				//$('.dimmed-layer').hide();
			}
		}
		*/
		
		if(this._btnSelector != undefined && $target != undefined){
			$('.js-popup-btn').removeClass('on');
			//$target.addClass('on');
		}
		
		this._$popup.attr('tabindex' , '0').css({
			'left' : ($(window).width() / 2) - (_this._$popup.outerWidth(true) / 2),
			'top' : ($(window).height() / 2) - (_this._$popup.outerHeight(true) / 2),
			'margin-left' : 0,
			'margin-top' : 0
		}).show().focus();

		if(this._dimmed){
			this._$dimmed.show();
		}
		
		// 포커스 제어
		/* 2015-03-31
		var time;
		if(time) clearTimeout(time);
		time = setTimeout(function(){
			_this._$popup.focus();
		} , 20 );
		*/

		$(window).bind('resize.popup_' + this._popupSelector, function(){
			_this._$popup.css({
				'left' : ($(window).width() / 2) - (_this._$popup.outerWidth(true) / 2),
				'top' : ($(window).height() / 2) - (_this._$popup.outerHeight(true) / 2),
				'margin-left' : 0,
				'margin-top' : 0
			})
		});
		
		// 현재 활성화된 버튼 클래스 주기
		if(this._btnSelector != undefined && $target != undefined){
			$('.js-active-popup').removeClass('js-active-popup');
			$target.addClass('js-active-popup');
		}
		
		// show callback
		if(typeof (this._option.show) === 'function'){
			this._option.show(this._$btn.eq(this._$popup.data('popup-btn-idx')) , this._$popup);
		}
		
		// 2015-08-20 팝업에 생성된 sub-select메뉴가 팝업안쪽에 가려 안보일때 위로 올라가도록 처리
		/*if(this._$popup.find('.js-sub-select').length > 0){
			this._$popup.find('.js-sub-select').each(function(i, tg){
				var $tg = $(tg);
				var popupHeight = _this._$popup.outerHeight();
				var layerTH = $tg.find('.layer-list').outerHeight() + $tg.position().top + $tg.outerHeight();
				if(popupHeight < layerTH) $tg.find('.layer-list').addClass('st02').css('top','auto');
			});	
		}*/
	}
	
	Popup.prototype.hide = function(){
		// hide callback
		if(typeof (this._option.hide) === 'function'){
			this._option.hide(this._$btn.eq(this._$popup.data('popup-btn-idx')) , this._$popup);
		}

		var _this = this;

		if(this._btnSelector != undefined) this._$btn.eq(this._$popup.data('popup-btn-idx')).removeClass('on').removeClass('js-active-popup').focus();
		this._$popup.removeAttr('tabindex').hide();
		
		if(!this._dimmed){
			if(!$('.js-popup').is(':visible')){
				$(document).unbind('click.popup_' + this._popupSelector);
			}
		}

		if(this._dimmed){
			this._$dimmed.hide();
		}

		$(window).unbind('resize.popup_' + this._popupSelector);
	}

	Popup.prototype.disable = function(){
		if(!this._initChk) return;
		
		if(this._btnSelector != undefined) this._$btn.removeClass('on').removeClass('js-active-popup').removeClass('js-popup-btn');
		this._$popup.removeClass('js-popup').removeAttr('tabindex').hide();
		$(document).unbind('.popup_' + this._popupSelector);
		$(window).unbind('resize.popup_' + this._popupSelector);
		
		if(this._btnSelector != undefined) this._$btn.unbind('.popup');
		this._$popup.unbind('.popup');
		this._$popup.find('a, button, input').eq(-1).unbind('.popup');

		this._$popup.find(this._closeSelector).unbind('.popup');
		
		if(this._drag){
			if(this._$popup.draggable('instance') != undefined) this._$popup.draggable('destroy');
			this._$popup.find('*').andSelf().unbind('scroll.popup');
		}
		if(this._dimmed){
			this._$dimmed.unbind('.popup');
			this._$dimmed.remove();
		}

		// all events unbind
		this._$popup.unbind();
		this._$popup.find('*').unbind();

		this._initChk = false;
	}
	
	Popup.prototype.enable= function(){
		this.init();
	}

	Popup.prototype.destroy = function(){
		this.disable();
		if(this._clone){
			this._$popup.remove();
		} else {
			this._$popup.after(this._$popupBackup);
			this._$popup.remove();
		}

		$(window).unbind('customEvent.globalLayerDelete' , this._globalLayerDeleteHandler);
		$(window).unbind('resize.popup_' + this._popupSelector);

		this._option = null;
		this._initChk = null;
		this._$win = null;
		this._$wrap = null;
		this._btnSelector = null;
		this._popupSelector = null;
		this._clone = null;
		this._panelClass = null;
		this._drag = null;
		this._dimmed = null;
		this._dimmedColor = null;
		this._$dimmed = null;
		this._closeSelector = null;
		this._okSelector = null;
		this._cancelSelector = null;
		this._yesSelector = null;
		this._noSelector = null;
		this._$btn = null;
		this._$popupBackup = null;
		this._keyEvt = null;
		this._btnEvt = null;
		this._rgbToHex = null;
		this.init = null;
		this.show = null;
		this.hide = null;
		this.disable = null;
		this.enable = null;
		this.addEvt = null;
		this.destroy = null;
	}
	
	Popup.prototype.addEvt = function(){
		var opts = {
			self : this,
			btn : this._$btn,
			popup : this._$popup
		}
		this._option.addEvt(opts);
	}

	return Popup;
})(jQuery);